import { Button, Col, Input, Modal, Radio, Row, Select, message } from "antd";
import { GoPlus } from "react-icons/go";

import { useMutation, useQuery } from "@tanstack/react-query";
import { Form } from "antd";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import PhoneInputWithCountrySelect, {
  parsePhoneNumber,
} from "react-phone-number-input";
import {
  AddNewLocation,
  adminGetPricingPlans,
  getLocationsAdmin,
} from "../../../network/admin";
import { getTeamSize } from "../../../network/onboarding";
import { listServicesCategories } from "../../../network/service";
import queryClient from "../../../services/react-query/queryClient";
import { queryKeys } from "../../../services/react-query/queryKeys";
import GenderSwitch from "../../common/GenderSwitch";
import AddressLocation from "../../settings/TapsSalon/components/AddresLocation";
import UploadPermit from "./UploadPermit";

const mapApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

const SalonModal = ({ modal, closeModal, type }: any) => {
  const {
    data: services,
    isLoading,
    isError,
  } = useQuery([queryKeys?.listServicesOnboarind], () =>
    listServicesCategories({ is_parent: 1 })
  );
  const [newLatLng, setNewLatLng] = useState<any>({
    lat: 24.774265,
    lng: 46.738586,
  });
  const [mapInfo, setMapInfo] = useState("");

  const intl = useIntl();
  const [active, setActive] = useState("both");
  const [isNewSalon, setIsNewSalon] = useState("New_Salon");
  const [fileData, setFileData] = useState<any>({});

  const [mainOptions, setMainOptions] = useState<any>([]);
  const [secondaryOptions, setSecondaryOptions] = useState<any>([]);

  const { Option } = Select;
  const [form] = Form.useForm();
  const changeGender = (e: any) => {
    setActive(e.target.value);
    console.log(e.target.value);
  };
  const isOnSite = type === "Salon";
  const [markerPosition, setMarkerPosition] = useState<any>({
    lat: 24.774265,
    lng: 46.738586,
  });
  const [selectedLocation, setSelectedLocation] = useState("Riyadh");
  const { mutate: onAddNewLocation, isLoading: isLoadingAddLocation } =
    useMutation((body: any) => AddNewLocation(body), {
      onSuccess: (res: any) => {
        if (res?.response?.status === 422 || res?.response?.status === 500) {
          message.error(res?.response?.data?.message);
        } else {
          queryClient.invalidateQueries(["AdminLocations"]);
          closeModal();
        }
      },
      onError: (error) => {
        message.error("حاول مرة اخرى");
      },
    });
  const { data: salons } = useQuery(["AdminLocations"], () =>
    getLocationsAdmin()
  );
  useEffect(() => {
    if (services?.data) {
      const mainOpts = services?.data?.map((e: any) => {
        return {
          label: e?.name,
          value: e?.id,
        };
      });
      setMainOptions(mainOpts);
      setSecondaryOptions(mainOpts); // Set initial options for secondary select
    }
  }, [services?.data]);
  const handleMainBusinessTypeChange = (selectedValue: any) => {
    // This assumes `selectedValue` is the newly selected value in the main select
    const newSecondaryOptions = services?.data
      ?.filter((service: any) => service?.id !== selectedValue)
      .map((service: any) => ({
        label: service?.name,
        value: service?.id,
      }));

    setSecondaryOptions(newSecondaryOptions);
  };
  const handleSecondaryBusinessTypeChange = (selectedValues: any[]) => {
    // This assumes `selectedValues` is the array of newly selected values in the secondary select
    const newMainOptions = services?.data
      .filter((service: any) => !selectedValues?.includes(service?.id))
      .map((service: any) => ({
        label: service?.name,
        value: service?.id,
      }));

    setMainOptions(newMainOptions);
  };
  const AddSalon = (data: any, file?: any, skip = false, plan = 0) => {
    const phoneNumber: any = parsePhoneNumber(data?.phone);

    const formData = new FormData();
    console.log(phoneNumber?.nationalNumber);

    if (file) {
      // Ensure file is not undefined and check for originFileObj
      const actualFile = file.originFileObj ? file.originFileObj : file;
      formData.append("work_permit", actualFile);
    } else if (fileData) {
      // Fallback to use fileData from state if file parameter is not provided
      // Also check for originFileObj
      const actualFile = fileData.originFileObj
        ? fileData.originFileObj
        : fileData;
      formData.append("work_permit", actualFile);
    }

    {
      if (data?.salon_id !== "New_Salon") {
        formData.append("salon_id", data?.salon_id);
      } else {
        formData.append("name[ar]", data?.salon?.ar);
        formData.append("name[en]", data?.salon?.en);
        formData.append("team_size_id", data?.team_size_id);
        formData.append("website_url", data?.website_url);
      }
    }

    formData.append("email", data?.email);
    formData.append("type", isOnSite ? "onsite" : "freelancer");

    // formData.append("service_id", step2?.service_id);
    // formData.append(
    //   "location[primary_service_categories][1]",
    //   data?.service_id[0]
    // );
    // data?.service_id
    //   .slice(1)
    //   .map((e: any, i: any) =>
    //     formData.append(
    //       `location[secondary_service_categories][${i}]`,
    //       data?.service_id[i]
    //     )
    //   );

    // formData.append("work_permit", null);

    if (!isOnSite) {
      formData.append("location[contact_number]", phoneNumber?.nationalNumber);
      formData.append("location[contact_country_code]", phoneNumber?.country);
    } else {
      formData.append("location[name][ar]", data?.name?.ar);
      formData.append("location[name][en]", data?.name?.en);
      formData.append("location[lat]", newLatLng?.lat);
      formData.append("location[lng]", newLatLng?.lng);

      formData.append("location[contact_number]", phoneNumber?.nationalNumber);
      formData.append("location[contact_country_code]", phoneNumber?.country);
      formData.append("location[email]", data?.email);
      formData.append(
        "location[business_location][Building]",
        data?.business_location?.Building
      );
      formData.append("location[business_location][Address]", mapInfo);
      formData.append(
        "location[business_location][City]",
        data?.business_location?.City
      );
      formData.append(
        "location[business_location][Country]",
        data?.business_location?.Country
      );
      formData.append(
        "location[business_location][District]",
        data?.business_location?.District
      );
      formData.append(
        "location[business_location][streetName]",
        data?.business_location?.streetName
      );
    }
    // formData.append("plan_id", plan || data?.plan);
    formData.append("plan_id", data?.plan_id);

    // onAddSalon(formData);
    // for (let [key, value] of formData.entries()) {
    //   console.log(`${key}: ${value}`);
    // }
    onAddNewLocation(formData);
  };
  const onFinish = (values: any) => {
    const formData = new FormData();
    AddSalon(values);
  };
  const { data: TeamSizeData } = useQuery<any>(
    [queryKeys?.listClient, queryKeys.listLocations],
    () => getTeamSize()
  );
  const { data: plans } = useQuery(["plans"], () => {
    return adminGetPricingPlans(); // Added return statement here
  });
  console.log(plans?.data?.data);
  const handleKeyDown = (event: any) => {
    if (event.key === "Enter") {
      event.preventDefault(); // Stop the form from submitting
    }
  };
  return (
    <Modal
      centered
      open={modal}
      onCancel={closeModal}
      okButtonProps={{ disabled: true }}
      cancelButtonProps={{ disabled: true }}
      footer={null}
      width={1060}
      maskClosable={false}
      className="px-6 py-4 salon"
    >
      <h3 className="flex items-center justify-center w-full my-8 text-2xl font-semibold text-color-primary">
        {isOnSite ? "New Salon" : "New salon ( Freelancer )"}
      </h3>
      <div onKeyDown={handleKeyDown}>
        <Form
          name="salon"
          form={form}
          onFinish={onFinish}
          layout={"vertical"}
          className="flex flex-col items-center justify-center w-full"
          initialValues={{
            available_for: "both",
            salon_id: "New_Salon",
            plan_id: 1,
            team_size_id: 1,
          }}
        >
          <Form.Item
            label="Salon"
            name={"salon_id"}
            className="w-full max-md:w-full max-xl:w-[25rem]"
            // rules={[{ required: true, message: "" }]}
            required={false}
          >
            <Select
              defaultValue={"New_Salon"}
              placeholder="choose salon"
              onChange={(e) => setIsNewSalon(e)}
            >
              {salons?.data?.map((e: any) => {
                return (
                  <Option value={e?.salon_id}>
                    <span className="text-[#75757E] text-sm">{e?.name}</span>
                  </Option>
                );
              })}
              <Option className="flex items-center" value="New_Salon">
                <div className="flex items-center">
                  <GoPlus className="flex items-center justify-center text-color-primary" />
                  <span className="text-sm font-semibold text-color-primary">
                    Add New Salon
                  </span>
                </div>
              </Option>
            </Select>
          </Form.Item>
          {isNewSalon === "New_Salon" ? (
            <div className="grid grid-cols-2 gap-4 bg-[#EEF0FF] px-2 mb-2 pt-2 w-full rounded-lg">
              <Form.Item
                label={<div className="text-sm">الاسم بالعربي</div>}
                name={["salon", "ar"]}
                className="h-fit"
                rules={[{ required: true, message: "أسم مشروعك" }]}
                required={false}
              >
                <div>
                  <Input placeholder="ادخل الاسم بالعربي" />
                </div>
              </Form.Item>
              <Form.Item
                label={<div className="text-sm">Salon Name ( in english )</div>}
                name={["salon", "en"]}
                className="h-fit"
                rules={[{ required: true, message: "salon name" }]}
                required={false}
              >
                <div>
                  <Input placeholder="branch name" />
                </div>
              </Form.Item>
              <Form.Item
                label={<div className="text-sm">Number Of Staff</div>}
                name="team_size_id"
                className="h-fit"
                // rules={[{ required: true, message: "Number Of Staff" }]}
                required={false}
              >
                <Select defaultValue={1}>
                  {TeamSizeData?.data?.map((e: any) => {
                    return (
                      <Option value={e?.id}>
                        <div className="flex items-center justify-between w-full gap-1">
                          <span className="text-[#75757E] text-sm">
                            {e?.name}
                          </span>
                          <span className="text-[#75757E] text-sm">
                            {e?.max_size
                              ? `${e?.min_size} - ${e?.max_size}`
                              : `+${e?.min_size}`}
                          </span>
                        </div>
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
              <Form.Item
                label={<div className="text-sm">Salon Website</div>}
                name={"website_url"}
                className="h-fit"
                required={false}
                hasFeedback
              >
                <div>
                  <Input placeholder="Salon website" />
                </div>
              </Form.Item>
              <Form.Item
                label={<div className="text-sm">Pricing plan</div>}
                name="plan_id"
                className="col-span-2 h-fit"
                // rules={[{ required: true, message: "select plan" }]}
                required={false}
              >
                <Select defaultValue={1}>
                  {plans?.data?.data?.map((e: any) => {
                    return (
                      <Option value={e?.id}>
                        <div className="flex items-center justify-between w-full gap-1">
                          <span className="text-[#75757E] text-sm">
                            {e?.name}
                          </span>
                          <span className="text-[#75757E] text-sm">
                            {e?.price} SR
                          </span>
                        </div>
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </div>
          ) : null}
          <div className="grid w-full grid-cols-2 gap-6 gap-y-0">
            <Form.Item
              label="الاسم بالعربي"
              name={["name", "ar"]}
              className="w-full max-md:w-full max-xl:w-[25rem]"
              rules={[{ required: true, message: "أسم مشروعك" }]}
              required={false}
              hasFeedback
            >
              <Input placeholder="أدخل أسم مشروعك هنا" />
            </Form.Item>
            <Form.Item
              label="Name ( in english )"
              name={["name", "en"]}
              className="w-full max-md:w-full max-xl:w-[25rem]"
              rules={[{ required: true, message: "أسم مشروعك" }]}
              required={false}
              hasFeedback
            >
              <Input placeholder="أدخل أسم مشروعك هنا" />
            </Form.Item>
            <Form.Item
              label="phone number"
              name="phone"
              required={false}
              rules={[
                {
                  required: true,
                  message: "ادخل رقم الجوال",
                },
              ]}
              className=""
              hasFeedback
            >
              <PhoneInputWithCountrySelect
                defaultCountry="SA"
                // value={value}
                // onChange={setValue}
                international
                hasFeedback
                limitMaxLength={true}
                className="!border-[1px] !border-solid !border-color-primary !py-2 !px-[11px] !h-[42px]"
                onChange={() => {}}
              />
            </Form.Item>
            <Form.Item
              name={"email"}
              label="Email address"
              rules={[
                {
                  required: true,
                  type: "email",
                  message: "ادخل البريد الإلكتروني",
                },
              ]}
              required={false}
              hasFeedback
              className=""
            >
              <Input placeholder="ادخل البريد الإلكتروني" />
            </Form.Item>
            <Form.Item
              name={"primary_service_categories"}
              label={
                <div className="text-sm">
                  {intl.formatMessage({ id: "mainBusinessTypeLabel" })}
                </div>
              }
              className="w-full"
              required={false}
              rules={[
                {
                  required: true,
                  message: intl.formatMessage({ id: "mainServiceRequired" }),
                },
              ]}
            >
              <Select
                defaultValue=""
                onChange={handleMainBusinessTypeChange}
                options={mainOptions}
                className="w-full"
              />
            </Form.Item>
            <Form.Item
              name={"secondary_service_categories"}
              required={false}
              rules={[
                {
                  required: true,
                  message: intl.formatMessage({
                    id: "secondaryServiceRequired",
                  }),
                },
              ]}
              label={
                <div className="text-sm">
                  {intl.formatMessage({ id: "secondaryBusinessTypeLabel" })}
                </div>
              }
            >
              <Select
                mode="multiple"
                style={{ width: "100%" }}
                defaultValue={[]}
                onChange={handleSecondaryBusinessTypeChange}
                optionLabelProp="label"
                options={secondaryOptions}
                maxLength={1}
              />
            </Form.Item>
            <Form.Item
              name="available_for"
              required={false}
              rules={[{ required: true }]}
              className="w-full col-span-2"
            >
              <div className="flex items-center justify-between">
                <div className="gutter-row">
                  <label className="w-full mt-3 text-xl font-normal leading-6 tracking-wider text-right">
                    Clients preferred gender
                  </label>
                </div>
                <div className="ml-2 gutter-row">
                  <Radio.Group onChange={changeGender} defaultValue={"both"}>
                    <Row
                      gutter={{ xs: 8, sm: 0, md: 24, lg: 14 }}
                      justify={"space-between"}
                    >
                      <Col className="gutter-row">
                        <GenderSwitch
                          active={"woman" === active}
                          gender="woman"
                          string={intl.formatMessage({ id: "woman" })}
                        />
                      </Col>
                      <Col className="gutter-row">
                        <GenderSwitch
                          active={"man" === active}
                          gender="man"
                          string={intl.formatMessage({ id: "man" })}
                        />
                      </Col>
                      <Col className="gutter-row">
                        <GenderSwitch
                          active={"both" === active}
                          gender="both"
                          string={intl.formatMessage({ id: "both" })}
                        />
                      </Col>
                    </Row>
                  </Radio.Group>
                </div>
              </div>
            </Form.Item>
            {/* {isOnSite ? (
            <div className="flex flex-col col-span-2">
              <h5 className="px-4 -mb-4 text-base font-medium">
                Salon address
              </h5>
              <DetailsLocation
                selectedLocation={selectedLocation}
                className="bg-white"
              />
              <GoogleMapComponent
                fo={form}
                mapApiKey={mapApiKey}
                setSelectedLocation={setSelectedLocation}
                selectedLocation={selectedLocation}
                markerPosition={markerPosition}
                setMarkerPosition={setMarkerPosition}
              />
            </div>
          ) : null} */}
            {isOnSite ? (
              <div className="flex flex-col col-span-2">
                <h5 className="mb-4 text-base font-medium">Salon address</h5>
                {/* <DetailsLocation
                selectedLocation={selectedLocation}
                className="bg-white"
              />
              <GoogleMapComponent
                fo={form}
                mapApiKey={mapApiKey}
                setSelectedLocation={setSelectedLocation}
                selectedLocation={selectedLocation}
                markerPosition={markerPosition}
                setMarkerPosition={setMarkerPosition}
              /> */}
                <AddressLocation
                  form={form}
                  setMapInfo={setMapInfo}
                  mapInfo={mapInfo}
                  setNewLatLng={setNewLatLng}
                  newLatLng={newLatLng}
                  isEdit={true}
                  label={"عنوان الفرع"}
                  name="business_location"
                  business_location={{}}
                />
              </div>
            ) : null}
            <UploadPermit fileData={fileData} setFileData={setFileData} />
          </div>
          <div className="flex w-full gap-4 mt-8">
            <Button
              type="primary"
              htmlType="submit"
              block
              loading={isLoadingAddLocation}
            >
              Add Salon
            </Button>
            <Button onClick={closeModal} type="default" htmlType="button" block>
              {intl.formatMessage({
                id: "cancel",
                defaultMessage: "إالغاء",
              })}
            </Button>
          </div>
        </Form>
      </div>
    </Modal>
  );
};

export default SalonModal;
